import $api from '@/api/index'

// 上传模块
const uploadFile = {
  state: {
    AliUploadTime: 0,
    AliUploadSys: ''
  },
  mutations: {
    setUploadSys: (state, data) => {
      state.AliUploadSys = data
      state.AliUploadTime = Date.now()
    }
  },
  actions: {
    getUploadInfo: ({commit}) => {
      $api.UploadSys(res => {
        commit('setUploadSys', res)
      })
    }
  }
}

export default uploadFile



// WEBPACK FOOTER //
// ./src/store/upload.js